export function configureTranslateProvider($translateProvider) {
    'ngInject';

    $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
}



// WEBPACK FOOTER //
// ./src/lib/providers/translate-provider.config.ts